import _ from 'lodash';
import { setDevice } from '@/api';
import { EventBus } from '@/event-bus';
import {
  SET_MESSAGING,
} from './mutation-types';

export default {
  state: {
    messaging: null,
    token: null,
  },
  actions: {
    ACT_SET_MESSAGING: ({ commit, dispatch }, {
      messaging,
    }) => {
      if (messaging) {
        messaging.getToken().then((currentToken) => {
          dispatch('ACT_MESSAGING_ON_TOKEN', currentToken);
        });
        messaging.onTokenRefresh(() => {
          messaging.getToken().then((currentToken) => {
            setDevice({
              oldToken: localStorage.getItem('fcm_token') || null,
              newToken: currentToken,
            }).finally(() => dispatch('ACT_MESSAGING_ON_TOKEN_REFRESH'));
          });
        });
        messaging.onMessage((payload) => {
          dispatch('ACT_MESSAGING_ON_MESSAGE', payload);
        });
        commit(SET_MESSAGING, messaging);
      }
    },
    ACT_MESSAGING_ON_TOKEN: (context, payload) => {
      console.log('[FCM] MESSAGING_ON_TOKEN', payload);
      localStorage.setItem('fcm_token', payload);
    },
    ACT_MESSAGING_ON_TOKEN_REFRESH: (context, payload) => {
      console.log('[FCM] MESSAGING_ON_TOKEN_REFRESH', payload);
      localStorage.setItem('fcm_token', payload);
    },
    ACT_MESSAGING_ON_MESSAGE: ({ dispatch }, payload) => {
      console.log('[FCM] ACT_MESSAGING_ON_MESSAGE', payload);
      const type = _.get(payload, 'data.notification_type');
      const id = _.get(payload, 'data.order');
      switch (type) {
        case 'order_chat_message':
          EventBus.$emit('new.chat.message', {
            id,
          });
          break;
        default:
      }
      dispatch('notifications/ACT_FETCH_NOTIFICATIONS', {
        referenceId: null,
        withRef: false,
      }, { root: true });
    },
  },
  mutations: {
    [SET_MESSAGING](state, payload) {
      state.messaging = payload;
    },
  },
  namespaced: true,
};
